import { useLingui } from '@lingui/react/macro';

import { BoneLossSvg } from './BoneLossSvg';
import { CavityDecaySvg } from './CavityDecaySvg';
import { EarlyStageCavitySvg } from './EarlyStageCavitySvg';
import { PlaqueBuildupSvg } from './PlaqueBuildupSvg';

export const LegendItem = ({
  icon,
  label,
}: {
  icon: React.ReactNode;
  label: string;
}) => (
  <div className="vai-flex vai-items-center vai-gap-2">
    {icon}
    <p className="vai-font-inter vai-text-[12px] vai-font-medium vai-text-zinc-500">
      {label}
    </p>
  </div>
);

export const PatientPrintoutLegend = () => {
  const { t } = useLingui();

  return (
    <div className="vai-flex vai-flex-wrap vai-gap-2 vai-mt-4">
      <LegendItem icon={<CavityDecaySvg />} label={t`Cavity decay`} />
      <LegendItem icon={<PlaqueBuildupSvg />} label={t`Plaque buildup`} />
      <LegendItem
        icon={<EarlyStageCavitySvg />}
        label={t`Early-stage cavity`}
      />
      <LegendItem icon={<BoneLossSvg />} label={t`Bone loss`} />
    </div>
  );
};
